import { useQuery } from "@tanstack/react-query";
import { dashApi } from "@/lib/dashApi";
import { useAuth } from "@/lib/auth";
import { EmptyState, ErrorState, LoadingState, PageHeader, Panel, StatusPill } from "@/components/dash/ui";
import { PriorityRow } from "./PrioritiesPage";

export default function RiskRegisterPage() {
  const auth = useAuth();
  const isAdmin = (auth.user?.roles ?? []).includes("admin");
  const q = useQuery({ queryKey: ["decisions-risks"], queryFn: dashApi.decisionsRisks });
  const active = q.data?.categories.filter((c) => c.count > 0) ?? [];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Risk Register"
        description="Open risks grouped by category — revenue, customer, operations, support, stock and connector / data quality."
        right={q.data && <span className="text-xs text-slate-500">{q.data.total} open risk(s)</span>}
      />
      {q.isLoading ? <LoadingState /> : q.isError ? <ErrorState error={q.error} /> : !active.length ? (
        <Panel title="Risk Register"><EmptyState>No open risks across any category.</EmptyState></Panel>
      ) : (
        active.map((cat) => (
          <Panel
            key={cat.category}
            title={cat.label}
            right={<div className="flex items-center gap-2">
              {cat.max_severity && <StatusPill status={cat.max_severity} />}
              <span className="rounded-full bg-ink-700 px-2 py-0.5 text-[11px] text-slate-400">{cat.count}</span>
            </div>}
          >
            <ul className="divide-y divide-ink-500/40">
              {cat.items.map((p) => <PriorityRow key={p.key} p={p} isAdmin={isAdmin} />)}
            </ul>
          </Panel>
        ))
      )}
    </div>
  );
}
